import { render } from "./CIS-Home-Blockquote.vue?vue&type=template&id=242513d1"
import script from "./CIS-Home-Blockquote.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Blockquote.vue?vue&type=script&lang=js"

import "./CIS-Home-Blockquote.vue?vue&type=style&index=0&id=242513d1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__